/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { PriceStatus } from './PriceStatus';
import {
    PriceStatusFromJSON,
    PriceStatusFromJSONTyped,
    PriceStatusToJSON,
    PriceStatusToJSONTyped,
} from './PriceStatus';

/**
 * 
 * @export
 * @interface PriceForProductDto
 */
export interface PriceForProductDto {
    /**
     * 
     * @type {number}
     * @memberof PriceForProductDto
     */
    priceUnitId: number;
    /**
     * 
     * @type {string}
     * @memberof PriceForProductDto
     */
    priceUnitDescription: string | null;
    /**
     * 
     * @type {number}
     * @memberof PriceForProductDto
     */
    productId: number;
    /**
     * 
     * @type {string}
     * @memberof PriceForProductDto
     */
    productName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PriceForProductDto
     */
    validFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof PriceForProductDto
     */
    validTo: Date;
    /**
     * 
     * @type {PriceStatus}
     * @memberof PriceForProductDto
     */
    priceStatus: PriceStatus;
    /**
     * 
     * @type {string}
     * @memberof PriceForProductDto
     */
    currency: string | null;
    /**
     * 
     * @type {number}
     * @memberof PriceForProductDto
     */
    rrp: number;
    /**
     * 
     * @type {number}
     * @memberof PriceForProductDto
     */
    lp: number;
    /**
     * 
     * @type {number}
     * @memberof PriceForProductDto
     */
    rm: number;
}



/**
 * Check if a given object implements the PriceForProductDto interface.
 */
export function instanceOfPriceForProductDto(value: object): value is PriceForProductDto {
    if (!('priceUnitId' in value) || value['priceUnitId'] === undefined) return false;
    if (!('priceUnitDescription' in value) || value['priceUnitDescription'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('validFrom' in value) || value['validFrom'] === undefined) return false;
    if (!('validTo' in value) || value['validTo'] === undefined) return false;
    if (!('priceStatus' in value) || value['priceStatus'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('rrp' in value) || value['rrp'] === undefined) return false;
    if (!('lp' in value) || value['lp'] === undefined) return false;
    if (!('rm' in value) || value['rm'] === undefined) return false;
    return true;
}

export function PriceForProductDtoFromJSON(json: any): PriceForProductDto {
    return PriceForProductDtoFromJSONTyped(json, false);
}

export function PriceForProductDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceForProductDto {
    if (json == null) {
        return json;
    }
    return {
        
        'priceUnitId': json['priceUnitId'],
        'priceUnitDescription': json['priceUnitDescription'],
        'productId': json['productId'],
        'productName': json['productName'],
        'validFrom': (new Date(json['validFrom'])),
        'validTo': (new Date(json['validTo'])),
        'priceStatus': PriceStatusFromJSON(json['priceStatus']),
        'currency': json['currency'],
        'rrp': json['rrp'],
        'lp': json['lp'],
        'rm': json['rm'],
    };
}

export function PriceForProductDtoToJSON(json: any): PriceForProductDto {
    return PriceForProductDtoToJSONTyped(json, false);
}

export function PriceForProductDtoToJSONTyped(value?: PriceForProductDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceUnitId': value['priceUnitId'],
        'priceUnitDescription': value['priceUnitDescription'],
        'productId': value['productId'],
        'productName': value['productName'],
        'validFrom': (formatDateOnly(value['validFrom'])),
        'validTo': (formatDateOnly(value['validTo'])),
        'priceStatus': PriceStatusToJSON(value['priceStatus']),
        'currency': value['currency'],
        'rrp': value['rrp'],
        'lp': value['lp'],
        'rm': value['rm'],
    };
}

